import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import { store, persistor } from 'redux/store';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import semiDarkTheme from 'utilities/mui/semiDarkTheme';
import { SnackbarProvider } from 'notistack';

import { injectStore } from "api/axios";
injectStore(store);

const LoadingMarkup = () => (
  <div
    style={{
      flex: 1,
      justifyContent: 'center',
    }}>
    <div size="large" color="#0000ff" >Persisting data</div>
  </div>
);

const theme = semiDarkTheme

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingMarkup />} persistor={persistor}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3}>
          <ThemeProvider theme={theme}>
            <Router>
              <App />
            </Router>
          </ThemeProvider>
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode >,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();